import {
  useDynamicComponentEntityStore,
} from "%/dynamic-components/render-engine/stores/dynamic-component-entity-store";
import DynamicComponentError from "%/errors/dynamic-component-error";

const DynamicEntityMixin = {
  mounted() {
    this.loadEntityIfRequired();
  },
  computed: {
    entity() {
      const dynamicComponentEntityStore = useDynamicComponentEntityStore();
      if (dynamicComponentEntityStore.entities[this.parentDynamicComponentName]) {
        return useDynamicComponentEntityStore().entities[this.parentDynamicComponentName][this.entityId] ?? {};
      }
      return {};
    },
    hasEntity() {
      return Object.keys(this.entity).length > 0;
    },
    hasValidGetEntityMethod() {
      return typeof this.getExampleEntity === "function" && typeof this.getRealEntity === "function";
    },
    parentDynamicComponentName() {
      let component = this;
      while (component) {
        if (component.$options.name === "DynamicComponentStaging" || component.$options.name === "DynamicComponentProduction") {
          return component.dynamicComponentName;
        }
        component = component.$parent;
      }
    },
  },
  methods: {
    getSmartFeedEntityStore() {
      if (!this.$options.entityStore || typeof this.$options.entityStore !== "function") {
        throw new DynamicComponentError("Dynamic component element which extends SmartFeedEntityDynamicElementMixin must define an entityStore", {
          componentName: this.$options.name,
        });
      }
      return this.$options.entityStore(this.$pinia);
    },
    getRealEntity() {
      const entityStore = this.getSmartFeedEntityStore();
      if (!entityStore.entities[this.entityId]) {
        throw new DynamicComponentError("Dynamic component element entity store does not contain entity", {
          componentName: this.$options.name,
          entityStoreId: entityStore.$id,
        });
      }
      return entityStore.entities[this.entityId];
    },
    async loadEntityIfRequired() {
      const dynamicComponentEntityStore = useDynamicComponentEntityStore();
      if (!dynamicComponentEntityStore.getEntityLoadingState(this.parentDynamicComponentName, this.entityId)) {
        if (this.hasEntity || !this.hasValidGetEntityMethod) {
          return;
        }

        dynamicComponentEntityStore.markEntityAsLoading(this.parentDynamicComponentName, this.entityId);

        const getEntity = () => {
          if (this.editMode) {
            return this.getExampleEntity();
          }
          return this.getRealEntity();
        };

        try {
          const entityPromise = getEntity();
          if (!entityPromise) {
            return;
          }
          const entity = await entityPromise;
          useDynamicComponentEntityStore().addEntityToStore(this.parentDynamicComponentName, this.entityId, entity);
        } catch {
          // ignore — entity load failures handled by finally block
        } finally {
          dynamicComponentEntityStore.markEntityAsNotLoading(this.parentDynamicComponentName, this.entityId);
        }
      }
    },
  },
};

export { DynamicEntityMixin };
